import "./import-global-dependencies";
import "./import-html-templates";
import "./import-desktop-modules";
import "./import-desktop-styles";
import "./import-images";

import "./app/app.react.desktop.bootstrap";
